module.exports = __webpack_public_path__ + "static/lap_windows-87c0e44484917a6fec109f15c8dead39.webp";